jQuery(document).ready(function(){
    new Swiper('.main-images-options.swiper-container', {
             loop: false,
             lazy: true,
             slidesPerView: 1,                  
             // If we need pagination
             pagination: {
                 el: '.swiper-pagination',
                 clickable: true,
                 renderBullet: function(index, className) {
                      return `<span class="outer-dot swiper-pagination-bullet" data-index="${
                           index + 1
                      }"><span class="inner-dot"></span></span>`;
                 }
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                 slideChange: function () {
                 let updatedIndex = this.realIndex + 1; // 1-based index
                 //alert('Current slide index:', this.realIndex);               
                 // Update current slide display
                 $('.swiper-slider-current-slide .current-slide').html('Current Slide: ' + updatedIndex);                                  
                 // Update pagination bullets
                 $('.swiper-pagination-bullet').removeClass('swiper-pagination-bullet-active');    
                 // Update only the bullet corresponding to the current slide
                 $('.swiper-pagination-bullet[data-index="' + updatedIndex + '"]').addClass('swiper-pagination-bullet-active');
               }
           }
     });     
});  
// Sabhi .continuetake elements ko target karna
document.querySelectorAll('.continuetake').forEach(function(element) {
    // Mouse enter event - jab hover karenge
    element.addEventListener('mouseenter', function() {
      // Previous sibling element ko get karna
      var previousElement = this.previousElementSibling;        
      // Agar previous element exist karta hai, toh display ko block karenge
      if (previousElement) {
            previousElement.style.display = 'block';
      }
    });
    // Mouse leave event - jab hover chhodenge
    element.addEventListener('mouseleave', function() {
        // Previous sibling element ko get karna
        var previousElement = this.previousElementSibling;
        // Agar previous element exist karta hai, toh display ko none karenge
        if (previousElement) {
            previousElement.style.display = 'none';
        }
    });
});  
$(document).ready(function(){
  $('.sidebar-filter-portion.mark_selcoll h3').click(function(){
    $(this).next('.mark_selultags').slideToggle();
    $(this).parent('.sidebar-filter-portion.mark_selcoll').toggleClass('actve-mark_s');
  });
  $(document).on('click', '.mobile-showsort', function(){
    $('.mobile-slideup').addClass('coming-slideup');
  });
  $(document).on('click', '.mobilesliup-closebtn', function(){
    $('.mobile-slideup').removeClass('coming-slideup');
  });
});